import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-i/imaging-procedures/lumbarSpineXRay";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	lumbarSpineXRay: {
		id: "form.lumbar_spine_x_ray",
		defaultMessage: "2 irányú lumbalis gerinc RTG"
	},
	result: {
		id: "form.lumbar_spine_x_ray.result",
		defaultMessage: "Eltérés"
	},
	comment: {
		id: "form.lumbar_spine_x_ray.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	},
	comment: {
		type: "field",
		path: ["resultComment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "lumbarSpineXRay",
	value: {
		title: messages.lumbarSpineXRay,
		validator,
		fieldset,
		isImportant: true
	}
};
